import type { FC } from 'react';
import type { LinkProps } from 'next/link';
import Link from 'next/link';

import type { Document } from '@models/Document';
import { useMdLink } from '@shared/NextLinks/hooks/use-md-link';

type NextMdLinkProps = LinkProps &
  React.ComponentProps<'a'> & {
    context: Document;
    className?: string;
  };

export const NextMdLink: FC<NextMdLinkProps> = ({ children, onClick, href, passHref, context, className }) => {
  const fullHref = useMdLink(href, context.navStructure);

  if (passHref) {
    return (
      <Link href={fullHref} passHref={passHref} legacyBehavior>
        {children}
      </Link>
    );
  }

  return (
    <Link href={fullHref} onClick={onClick} className={className}>
      {children}
    </Link>
  );
};
